(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('angular'), require('vue')) :
  typeof define === 'function' && define.amd ? define(['exports', 'angular', 'vue'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.ngVue = {}, global.angular, global.Vue));
})(this, (function (exports, angular, Vue) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var angular__default = /*#__PURE__*/_interopDefaultLegacy(angular);
  var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue);

  function _extends() {
    return _extends = Object.assign || function (a) {
      for (var b, c = 1; c < arguments.length; c++) for (var d in b = arguments[c], b) Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);

      return a;
    }, _extends.apply(this, arguments);
  }

  var normalMerge = ["attrs", "props", "domProps"],
      toArrayMerge = ["class", "style", "directives"],
      functionalMerge = ["on", "nativeOn"],
      mergeJsxProps = function (a) {
    return a.reduce(function (c, a) {
      for (var b in a) if (!c[b]) c[b] = a[b];else if (-1 !== normalMerge.indexOf(b)) c[b] = _extends({}, c[b], a[b]);else if (-1 !== toArrayMerge.indexOf(b)) {
        var d = c[b] instanceof Array ? c[b] : [c[b]],
            e = a[b] instanceof Array ? a[b] : [a[b]];
        c[b] = d.concat(e);
      } else if (-1 !== functionalMerge.indexOf(b)) {
        for (var f in a[b]) if (c[b][f]) {
          var g = c[b][f] instanceof Array ? c[b][f] : [c[b][f]],
              h = a[b][f] instanceof Array ? a[b][f] : [a[b][f]];
          c[b][f] = g.concat(h);
        } else c[b][f] = a[b][f];
      } else if ("hook" == b) for (var i in a[b]) c[b][i] = c[b][i] ? mergeFn(c[b][i], a[b][i]) : a[b][i];else c[b] = a[b];

      return c;
    }, {});
  },
      mergeFn = function (a, b) {
    return function () {
      a && a.apply(this, arguments), b && b.apply(this, arguments);
    };
  };

  var helper = mergeJsxProps;

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function isCompositionApi(component) {
    return angular__default["default"].isObject(component) && Object.prototype.hasOwnProperty.call(component, 'setup');
  }

  function getVueComponent(name, $injector) {
    var component = name;

    if (angular__default["default"].isString(name)) {
      component = $injector.get(name);
    }

    if (isCompositionApi(component)) {
      component = Vue__default["default"].component(component.name || 'UnnamedComponent', component);
    }

    return component;
  }

  function lowerFirst(letter) {
    var firstLetter = letter.charAt(0).toLowerCase();
    return firstLetter + letter.slice(1);
  }

  function extractPropName(attrPropName, removedKey) {
    var propKeyPattern = new RegExp("^".concat(removedKey));

    if (!propKeyPattern.test(attrPropName)) {
      return null;
    }

    var propName = attrPropName.slice(removedKey.length);
    return lowerFirst(propName);
  }

  /**
   * @param attributes Object
   * @returns {Array} Array of attributes that pass the filter
   */
  function extractHtmlAttributes(attributes) {
    // Filter out everything except for HTML attributes, e.g. tabindex, disabled
    return Object.keys(attributes).filter(function (attr) {
      var isSpecialAttr = /^(vProps|vData|vOn|vDirectives|watchDepth|ng)/i.test(attr);
      var isJqliteProperty = attr[0] === '$'; // Vue does not consider class or style as an attr

      return !isSpecialAttr && !isJqliteProperty && attr !== 'class' && attr !== 'style';
    });
  }

  function camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
  }

  /**
   * Extract a subset of expressions from the element attributes, e.g. property/data, on, or htmlAttribute
   *
   * @param exprType 'props'|'data'|'on'|'htmlAttributes'
   * @param attributes Object
   *
   * @returns {Object|string|null}
   */

  function extractExpressions(exprType, attributes) {
    var exprKeys = {
      props: 'vProps',
      data: 'vData',
      on: 'vOn'
    };
    var objectExprKey = exprKeys[exprType];
    var objectPropExprRegExp = new RegExp(objectExprKey, 'i');
    var objectExpr = attributes[objectExprKey];

    if (angular__default["default"].isDefined(objectExpr)) {
      return objectExpr;
    }

    var expressions;

    if (exprType === 'htmlAttributes') {
      expressions = extractHtmlAttributes(attributes);
    } else {
      expressions = Object.keys(attributes).filter(function (attr) {
        return objectPropExprRegExp.test(attr);
      });
    }

    if (expressions.length === 0) {
      return null;
    }

    var exprsMap = {
      /* name : expression */
    };
    expressions.forEach(function (attrExprName) {
      if (objectExprKey) {
        var exprName = extractPropName(attrExprName, objectExprKey);

        if (!exprName) {
          return;
        }

        exprsMap[exprName] = attributes[attrExprName];

        if (objectExprKey === 'vOn') {
          exprsMap[camelToKebab(exprName)] = attributes[attrExprName];
        }
      } else {
        // Non-prefixed attributes, i.e. a regular HTML attribute
        // Get original attribute name from $attr not stripped by Angular, e.g. data-qa and not qa
        var attrName = attributes.$attr[attrExprName];
        var attrValue; // Handle attributes with no value, e.g. <button disabled></button>

        if (attributes[attrExprName] === '') {
          attrValue = "'".concat(attrExprName, "'");
        } else {
          attrValue = attributes[attrExprName];
        }

        exprsMap[attrName] = attrValue;
      }
    });
    return exprsMap;
  }
  /**
   * @param attributes Object
   * @returns {{data: (Object|string|null), props: (Object|string|null)}}
   */

  function getExpressions(attributes) {
    return {
      data: extractExpressions('data', attributes),
      props: extractExpressions('props', attributes),
      events: extractExpressions('on', attributes),
      htmlAttributes: extractExpressions('htmlAttributes', attributes)
    };
  }

  function watch(expressions, reactiveData, type) {
    return function (watchFunc) {
      // for `v-props` / `v-data`
      if (angular.isString(expressions)) {
        watchFunc(expressions, Vue__default["default"].set.bind(Vue__default["default"], reactiveData._v, type));
        return;
      } // for `v-props-something`


      Object.keys(expressions).forEach(function (name) {
        watchFunc(expressions[name], Vue__default["default"].set.bind(Vue__default["default"], reactiveData._v[type], name));
      });
    };
  }
  /**
   * @param setter Function a reactive setter from VueJS
   * @param inQuirkMode boolean a quirk mode will fix the change detection issue
   *                            caused by the limitation of the reactivity system
   * @returns Function a watch callback when the expression value is changed
   */


  function notify(setter, inQuirkMode) {
    return function (newVal) {
      var value = newVal;

      if (inQuirkMode) {
        // `Vue.set` uses a shallow comparision to detect the change in the setters, and so
        // for an object and an array, we have to create a new one to force the reactivity
        // system to walk through all the properties to detect the change and to convert the
        // new values into a reactive data.
        value = angular.isArray(newVal) ? _toConsumableArray(newVal) : angular.isObject(newVal) ? _objectSpread2({}, newVal) : newVal;
      }

      setter(value);
    };
  }
  /**
   *
   * @param dataExprsMap Object
   * @param dataExprsMap.data Object|string|null
   * @param dataExprsMap.props Object|string|null
   * @param reactiveData Object
   * @param reactiveData._v Object
   * @param options Object
   * @param options.depth 'reference'|'value'|'collection'
   * @param options.quirk 'reference'|'value'|'collection'
   * @param scope Object
   * @param type String 'props'|'attrs'
   */


  function watchExpressions(dataExprsMap, reactiveData, options, scope, type) {
    var expressions;

    if (type === 'props') {
      expressions = dataExprsMap.props ? dataExprsMap.props : dataExprsMap.data;
    } else if (type === 'attrs') {
      expressions = dataExprsMap.htmlAttributes;
    }

    if (!expressions) {
      return;
    }

    var depth = options.depth,
        quirk = options.quirk;
    var watcher = watch(expressions, reactiveData, type);

    switch (depth) {
      case 'value':
        watcher(function (expression, setter) {
          scope.$watch(expression, notify(setter, quirk), true);
        });
        break;

      case 'collection':
        watcher(function (expression, setter) {
          scope.$watchCollection(expression, notify(setter, quirk));
        });
        break;

      case 'reference':
      default:
        watcher(function (expression, setter) {
          scope.$watch(expression, notify(setter, quirk));
        });
    }
  }

  /**
   * @param expr Object|string|null
   * @param scope Object
   * @returns {string|Object|null}
   */

  function evaluateValues(expr, scope) {
    if (!expr) {
      return null;
    }

    if (angular__default["default"].isString(expr)) {
      return scope.$eval(expr);
    }

    var evaluatedValues = {};
    Object.keys(expr).forEach(function (key) {
      evaluatedValues[key] = scope.$eval(expr[key]);
    });
    return evaluatedValues;
  }

  /**
   * @param dataExprsMap Object
   * @param dataExprsMap.events Object|null
   * @param scope Object
   * @returns {Object|null}
   */

  function evaluateEvents(dataExprsMap, scope) {
    var events = dataExprsMap.events;

    if (!events || !angular__default["default"].isObject(events)) {
      return null;
    }

    var evaluatedEvents = {};
    Object.keys(events).forEach(function (eventName) {
      evaluatedEvents[eventName] = scope.$eval(events[eventName]);
      var fn = evaluatedEvents[eventName];

      if (!angular__default["default"].isFunction(fn)) {
        return;
      }

      evaluatedEvents[eventName] = function () {
        var _arguments = arguments;
        return scope.$evalAsync(function () {
          return fn.apply(null, _arguments);
        });
      };
    });
    return evaluatedEvents;
  }

  function getTypeOf(value) {
    return value.constructor.name;
  }

  var transformers = {
    Object: function Object(value) {
      return [value];
    },
    Array: function Array(value) {
      return value;
    },
    String: function String(value) {
      return value.split(/\s*,\s*/g).filter(Boolean).map(function (name) {
        return {
          name: name
        };
      });
    }
  };
  /**
   *
   * v-directives:
   *  - Array: [{name: string, value: *, modifiers: Object, params: Object}]
   *  - Object: {name: string, value: *, modifiers: Object, params: Object}
   *  - String: a single directive name or multi-directive names separated with a comma
   *
   * @param attributes {{vDirectives: string|undefined}}
   * @param scope
   * @returns {Array|null}
   */

  function evaluateDirectives(attributes, scope) {
    var directivesExpr = attributes.vDirectives;

    if (angular__default["default"].isUndefined(directivesExpr)) {
      return null;
    }

    var directives = scope.$eval(directivesExpr);
    var transformer = transformers[getTypeOf(directives)];
    return transformer ? transformer(directives) : null;
  }

  var SPECIAL_ATTRIBUTE_KEYS = ['class', 'style'];
  function extractSpecialAttributes(attributes) {
    return SPECIAL_ATTRIBUTE_KEYS.reduce(function (specialAttributes, key) {
      var value = attributes[key];

      if (value || attributes[attributes.$normalize("ng-".concat(key))]) {
        specialAttributes[key] = value;
      }

      return specialAttributes;
    }, {
      /* name: value */
    });
  }

  function watchSpecialAttributes(reactiveData, element, scope) {
    Object.keys(reactiveData._v.special).forEach(function (key) {
      // Use scope.$watch instead of attrs.$observe because we want to catch changes in attribute
      // value that don't necessarily come directly from interpolation.
      scope.$watch(function () {
        return element.attr(key);
      }, function (newValue) {
        Vue__default["default"].set(reactiveData._v.special, key, newValue);
      });
    });
  }

  function ngVueLinker(componentName, jqElement, elAttributes, scope, $injector) {
    var _Component$options;

    if (!jqElement.parent().length) throw new Error('ngVue components must have a parent tag or they will not render');
    var $ngVue = $injector.has('$ngVue') ? $injector.get('$ngVue') : null;
    var dataExprsMap = getExpressions(elAttributes);
    var Component = getVueComponent(componentName, $injector);
    var directives = evaluateDirectives(elAttributes, scope) || [];
    var reactiveData = {
      _v: {
        props: evaluateValues(dataExprsMap.props || dataExprsMap.data, scope) || {},
        attrs: evaluateValues(dataExprsMap.htmlAttributes, scope) || {},
        special: extractSpecialAttributes(elAttributes)
      }
    };
    var on = evaluateEvents(dataExprsMap, scope) || {};
    var inQuirkMode = $ngVue ? $ngVue.inQuirkMode() : false;
    var rootProps = $ngVue ? $ngVue.getRootProps() : {};
    var mounted = rootProps.mounted;
    var props = Object.assign({}, rootProps);

    props.mounted = function () {
      var element = jqElement[0];

      if (element.innerHTML.trim()) {
        var html;

        if (element.children.length === 0) {
          var span = document.createElement('span');
          span.innerHTML = element.innerHTML.trim();
          html = span;
        } else {
          html = element.children[0];
        }

        var slot = this.$refs.__slot__;
        slot.parentNode.replaceChild(html, slot);
      }

      if (angular__default["default"].isFunction(mounted)) {
        mounted.apply(this, arguments);
      }
    };

    var watchOptions = {
      depth: elAttributes.watchDepth,
      quirk: inQuirkMode
    };
    watchExpressions(dataExprsMap, reactiveData, watchOptions, scope, 'props');
    watchExpressions(dataExprsMap, reactiveData, watchOptions, scope, 'attrs');
    watchSpecialAttributes(reactiveData, jqElement, scope);
    var vueInstance = new Vue__default["default"](_objectSpread2({
      name: "NgVue-".concat(((_Component$options = Component.options) === null || _Component$options === void 0 ? void 0 : _Component$options.name) || 'UnnamedComponent'),
      el: jqElement[0],
      data: reactiveData,
      render: function render(h) {
        return h(Component, helper([{}, {
          directives: directives
        }, {
          "props": _objectSpread2({}, reactiveData._v.props),
          "on": _objectSpread2({}, on),
          "attrs": _objectSpread2({}, reactiveData._v.attrs)
        }, reactiveData._v.special]), [h("span", {
          "ref": "__slot__"
        })]);
      }
    }, props));
    scope.$on('$destroy', function () {
      vueInstance.$destroy();
      angular__default["default"].element(vueInstance.$el).remove();
      vueInstance = null;
    });
  }

  /**
   *
   * angular.module('vue.components')
   *  .value('HelloComponent', Vue.component('hello-component', {
   *    props: {
   *      firstName: String,
   *      lastName: String
   *    },
   *    render() {
   *      return <h1>Hello, {this.firstName} {this.lastName}</h1>
   *    }
   *  }))
   *
   * angular.module('vue.components')
   *  .directive('helloComponent', function (vueComponentFactory) {
   *    return vueComponentFactory('hello')
   *  })
   *
   * <hello-component v-props="person"></hello-component>
   *
   * <hello-component v-props-first-name="person.firstName" v-props-last-name="person.lastName"></hello-component>
   *
   * @param $injector
   * @returns {Function}
   */

  function ngVueComponentFactory($injector) {
    return function (componentName, ngDirectiveConfig) {
      var config = {
        restrict: 'E',
        link: function link(scope, elem, attrs) {
          ngVueLinker(componentName, elem, attrs, scope, $injector);
        }
      };
      return angular__default["default"].extend(config, ngDirectiveConfig);
    };
  }
  /**
   * <vue-component name="HelloComponent" v-props="person"></vue-component>
   *
   * @param $injector
   * @returns {{restrict: string, link: (function(*=, *=, *=))}}
   */


  function ngVueComponentDirective($injector) {
    return {
      restrict: 'E',
      link: function link(scope, elem, attrs) {
        var componentName = attrs.name;
        ngVueLinker(componentName, elem, attrs, scope, $injector);
      }
    };
  }

  var ngVue = angular__default["default"].module('ngVue', []).directive('vueComponent', ['$injector', ngVueComponentDirective]).factory('createVueComponent', ['$injector', ngVueComponentFactory]);

  exports.ngVue = ngVue;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
